import { render, staticRenderFns } from "./TUWEN007.vue?vue&type=template&id=04e6f8fe"
import script from "./TUWEN007.vue?vue&type=script&lang=js"
export * from "./TUWEN007.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports